module.exports = __webpack_public_path__ + "img/icon-jump-over.9be44901.png";